<template>
  <div>
    <div @click="closeModal" class="modal">
      <div class="modal-wrap">
        <h2>Delete User</h2>
        <p>
          You are about to permanently delete this user. This operation cannot
          be undone. Do you wish to continue?
        </p>
        <div class="buttons">
          <a @click.prevent="deleteUserEmit" class="button">Delete User</a>
          <a @click.prevent="closeModalClick" class="button">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "deleteUserModal",
  props: ["currentUID"],
  methods: {
    closeModalClick() {
      this.$emit("close-modal");
    },
    deleteUserEmit() {
      this.$emit("delete-user");
      this.$emit("close-modal");
    },
    // When clicked outside of the modal, this calls
    // and emit to be passed to the component
    // "ViewCategories" and closes the modal
    closeModal(e) {
      // sends a signal if the target clicked is not the modal wrap
      const modal = document.querySelector(".modal");
      if (e.target === modal) {
        this.$emit("close-modal");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.479);
  top: 0;
  z-index: 99;
  height: 100%;
  width: 100%;

  .modal-wrap {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    width: 500px;
    min-height: 300px;
    padding: 2rem;
    background-color: white;
  }

  h2 {
    margin-bottom: 12px;
  }

  .buttons {
    margin-top: auto;
    display: flex;

    .button {
      cursor: pointer;
      border-radius: 8px;
      padding: 12px;
      flex: 1;
      color: white;
      text-align: center;
      transition: 500ms ease all;
    }

    .button:nth-child(1) {
      background-color: red;
      margin-right: 16px;

      &:hover {
        background-color: rgba(255, 0, 0, 0.7);
      }
    }
    .button:nth-child(2) {
      background-color: #6236ff;
      margin-left: 16px;
      &:hover {
        background-color: rgba(98, 54, 255, 0.7);
      }
    }
  }
}
</style>
